import { useState, useContext, useEffect } from 'react';
import { GlobalContext } from 'GlobalContext';
import { message, Spin, Tooltip, Upload, Popconfirm, InputNumber } from 'antd';
import api from 'api';
import { get } from 'utils/fetch';
import { isPhoneSize } from 'utils/util';
import {
    FileOutlined,
    CloseCircleFilled,
    PlusOutlined,
} from '@ant-design/icons';
export function InvestmentInfo() {
    const { manageAssetId, setManageAssetId, accessToken, refreshSession } =
        useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const [propertyInvestmentInfo, setPropertyInvestmentInfo] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(true);

    // fields
    const [alphaXOwnerShip, setAlphaXOwnerShip] = useState(null);

    const entryStyle = {
        margin: '20px',
        fontSize: '20px',
    };

    const inputStyle = {
        border: '0',
        outline: 'none',
        borderBottom: '1px solid black',
        fontSize: '20px',
        background: 'transparent',
    };

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchPropertyInvestmentInfo(manageAssetId) {
        await get(
            api.asset.propertyInvestmentInfo(manageAssetId),
            setPropertyInvestmentInfo,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    useEffect(() => {
        if (propertyInvestmentInfo) {
            restore(propertyInvestmentInfo);
        }
    }, [propertyInvestmentInfo]);

    useEffect(() => {
        if (manageAssetId < 0) {
            return;
        }
        fetchPropertyInvestmentInfo(manageAssetId);
    }, []);

    function restore(propertyInvestmentInfo) {
        setAlphaXOwnerShip(propertyInvestmentInfo?.alphax_ownership);
    }

    function unchanged() {
        if (!propertyInvestmentInfo) return false;
        return alphaXOwnerShip === propertyInvestmentInfo.alphax_ownership;
    }

    async function upsert() {
        if (unchanged()) return;
        setLoading(true);
        const body = JSON.stringify({
            alphaXOwnerShip,
        });

        const options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body,
        };
        const response = await fetch(
            api.asset.upsertInvestment(manageAssetId),
            options
        );
        const data = await response.json();
        const idRes = data.data;
        refreshSession();
        if (idRes === 0) {
            messageApi.error({
                type: 'error', // or 'error', 'info', 'warning', 'loading'
                content: propertyInvestmentInfo?.id
                    ? 'Loan insertion failed'
                    : 'Loan update failed',
                duration: 3, // seconds (optional)
            });
        } else {
            messageApi.open({
                type: 'success', // or 'error', 'info', 'warning', 'loading'
                content: propertyInvestmentInfo?.id
                    ? 'Loan insertion success'
                    : 'Loan update success',
                duration: 3, // seconds (optional)
            });
            fetchPropertyInvestmentInfo(manageAssetId);
        }
        setEditMode(false);
    }

    async function deleteInvestment() {
        setLoading(true);

        const options = {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const response = await fetch(
            api.asset.deleteInvestment(manageAssetId),
            options
        );
        const data = await response.json();
        const idRes = data.data;
        refreshSession();

        if (idRes === 0 || !idRes) {
            messageApi.error({
                type: 'error',
                content: 'Investment deletion failed',
                duration: 3,
            });
        } else {
            messageApi.open({
                type: 'success',
                content: 'Investment deletion success',
                duration: 3,
            });
        }
        setPropertyInvestmentInfo(null);
        restore(null);
        setLoading(false);
    }

    return (
        <>
            {contextHolder}
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && (
                <div>
                    <div
                        style={{
                            width: 'fit-content',
                            marginLeft: '20px',
                            height: '38px',
                            position: 'fixed',
                            background: 'white',
                            width: '100%',
                            alignContent: 'end',
                            top: 40,
                        }}
                    >
                        <div
                            style={{
                                color: 'blue',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                width: 'fit-content',
                            }}
                            onClick={(e) => {
                                if (editMode) {
                                    restore(propertyInvestmentInfo);
                                }
                                setEditMode(!editMode);
                            }}
                        >
                            {editMode ? 'Restore' : 'Edit'}
                        </div>
                    </div>

                    <div
                        style={
                            isPhoneSize()
                                ? entryStyle
                                : {
                                      ...entryStyle,
                                      display: 'flex',
                                      marginTop: '50px',
                                  }
                        }
                    >
                        <div>AlphaX Ownership: </div>
                        {editMode ? (
                            <InputNumber
                                style={{
                                    outline: 'none',
                                    border: 'none',
                                    borderBottom: '1px solid black',
                                    width: 'auto', // optional, can adjust
                                }}
                                value={alphaXOwnerShip}
                                onChange={(value) => setAlphaXOwnerShip(value)} // value is already numeric or null
                                placeholder="alphax ownership"
                                controls={false} // hides up/down arrows
                            />
                        ) : (
                            <div>{alphaXOwnerShip || 0}</div>
                        )}
                        <div>%</div>
                    </div>

                    <div style={{ display: 'flex', marginLeft: '20px' }}>
                        <button
                            style={{
                                height: '30px',
                                width: '60px',
                                borderRadius: '30px',
                                background: 'rgb(17 32 86)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={upsert}
                        >
                            Save
                        </button>
                        <button
                            style={{
                                height: '30px',
                                width: '60px',
                                borderRadius: '30px',
                                background: 'rgb(86 17 17)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                if (
                                    window.confirm(
                                        'Are you sure you want to delete this loan?'
                                    )
                                ) {
                                    deleteInvestment();
                                }
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
